export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10036.17ba14b1.jpg";